import { render, staticRenderFns } from "./CadCombustivel.vue?vue&type=template&id=7dbe0f72&"
import script from "./CadCombustivel.vue?vue&type=script&lang=js&"
export * from "./CadCombustivel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports